











import { Vue, Component } from "@/shared/vuepack";

@Component
export default class AllegacyFooterCash extends Vue {
}
